import angular from 'angular';

export class StringService {
  constructor() {
    'ngInject';
  }

  /**
   * When provided a valid file name, returns the extension from it.
   * @param {string} fileName
   * @return {string | null}
   */
  public getExtensionFromFileName = (fileName: string): string | null => {
    if (fileName.indexOf('.') < 0) return null;
    return fileName.substr(fileName.lastIndexOf('.') + 1);
  };

  /**
   * If supplied text exceeds the provided character length, limit the text
   * and concat a [...]
   * @param {string} string to be manipulated
   * @param {number} limit
   */
  public limitString = (string: string, limit: number): string => {
    if (string.length <= limit) return string;
    return `${string.substring(0, limit)} [...]`;
  };
}

export default angular.module('services.stringService', [])
  .service('stringService', StringService)
  .name;
